import Sidebar from './Sidebar';
import LowStockAlertModal from '../alerts/LowStockAlertModal';
import PONotificationModal from '../notifications/PONotificationModal';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-100">
      <Sidebar />
      <main className="md:ml-64">
        {/* Add top padding on mobile for the hamburger menu button */}
        <div className="pt-14 md:pt-6 px-4 pb-4 md:px-8 md:pb-8 min-h-screen">
          {children}
        </div>
      </main>
      <LowStockAlertModal />
      <PONotificationModal />
    </div>
  );
};

export default Layout;
